import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Container,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Button,
} from "reactstrap";
import MetaTags from "react-meta-tags";

//Import Breadcrumb
import Breadcrumbs from "../../../components/common/Breadcrumb";
// import "../../../src/assets/scss/custom/plugins/_datatables.scss";
import { ApiCore } from "../../../helpers/api_helper";
import { Loading } from "../../../components/common/Loading";
import { AxiosResponse } from "axios";
import { Endpoints } from "../../../utils/Endpoints";
import { XTextBox } from "../../../components/common/inputs/XTextBox";
import { Form, Formik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { XSelect } from "../../../components/common/inputs/XSelect";
import { getForms } from "../../../utils/Helpers";
import { XCheckbox } from "../../../components/common/inputs/XCheckbox";
import { useHistory } from "react-router-dom";
import { XSearchableSelect } from "../../../components/common/inputs/XSearchableSelect";

const TerminalReports = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<any>({});
  const [data, setData] = useState<any>(null);
  const [students, setStudents] = useState<any>([]);

  const history = useHistory();

  const request = new ApiCore();

  const terms = [
    { value: "I", text: "I" },
    { value: "II", text: "II" },
    { value: "III", text: "III" },
  ];

  const categories = [{ value: "exam", text: "Exam" }];

  const getStudentsEndpoint = (values: any) => {
    let url = Endpoints.students + "?";

    if (values.form) {
      url += `form=${values.form}&`;
    }

    if (values.stream) {
      url += `stream=${values.stream}&`;
    }

    url = url.replace(/&$/,"");

    return url;
  }

  useEffect(() => {
    request
      .get(Endpoints.students, {})
      .then((response: AxiosResponse) => {
        const { students } = response.data;
        let options: any = [];
        options = students.map((data: any) => ({
          value: data.id,
          label:
            data.lastname +
            " " +
            data.firstname +
            " - " +
            data.studentid +
            " - " +
            data.form +
            " " +
            data.stream,
          data: JSON.stringify(data),
        }));
        setStudents(options);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleSubmit = (values: any) => {
    values.pdf = 1;
    if (!values.summary || values.summary != 1) {
      delete values.summary;
    }
    setInitialValues(values);
    toast
      .promise(request.get(Endpoints.ncterminalreport, { params: values }, "arraybuffer"), {
        pending: "Please wait..",
        success: {
          render({ data }) {
            return "The report is ready";
          },
        },
        error: {
          render({ data }) {
            return data;
          },
        },
      })
      .then((response: AxiosResponse) => {
        console.log(response);
        const type = response.headers['content-type']
        const blob = new Blob([response.data], {type: type})
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `marksheet-${values.form}-${values.stream}-${values.year}-${values.term}.pdf`
        link.click()
      });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Terminal Reports - Treda</title>
        </MetaTags>

        <Container fluid>
          <Breadcrumbs title="New Cirriculum" breadcrumbItem="Reports" />
          <Row>
            <Col md={12} lg={12} xl={12}>
              <Card>
                <CardHeader className="justify-content-between d-flex align-items-center">
                  <CardTitle className="h4">Terminal Reports</CardTitle>
                </CardHeader>
                <CardBody>
                  {loading && <Loading label="Loading marks. Please wait." />}
                  {!loading && (
                    <>
                      <Row className="mb-2">
                        <Col xl="12">
                          <ToastContainer />
                        </Col>
                      </Row>
                      <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validateOnBlur
                        onSubmit={(values: any) => handleSubmit(values)}
                      >
                        {({
                          isSubmitting,
                          setFieldValue,
                          values,
                          errors,
                          touched,
                        }) => (
                          <>
                            <Form>
                              <Row>
                                <Col lg={2}>
                                <XSearchableSelect
                                  allowAddNew={false}
                                  dataSrc={getStudentsEndpoint(values)}
                                  dataType={"students"}
                                  labelField="fullname"
                                  id="student_id"
                                  name="student_id"
                                  value="student_id"
                                  onChange={(value: any) => {
                                    setFieldValue("student_id", value.value);
                                  }}
                                  label="Student"
                                  touched={touched}
                                />
                                </Col>
                                <Col lg={2}>
                                  <XSelect
                                    key="form"
                                    id="form"
                                    name={"form"}
                                    options={getForms()}
                                    label={"Class"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={1}>
                                  <XTextBox
                                    type="text"
                                    key="stream"
                                    id="stream"
                                    name={"stream"}
                                    label={"Stream"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={1}>
                                  <XSelect
                                    key="term"
                                    id="term"
                                    name={"term"}
                                    options={terms}
                                    label={"Term"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XSelect
                                    key="marktype_id"
                                    id="marktype_id"
                                    name={"marktype_id"}
                                    dataSrc={Endpoints.marktypes}
                                    dataType={"marktypes"}
                                    labelField={"label"}
                                    label={"Mark Type"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={1}>
                                  <XTextBox
                                    type="text"
                                    key="year"
                                    id="year"
                                    name={"year"}
                                    label={"Year"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={1}>
                                  <XCheckbox
                                    key="email"
                                    id="email"
                                    name={"email"}
                                    label={"Email"}
                                    value="1"
                                    includeTopPadding={true}
                                    onChange={setFieldValue}
                                    size={{}}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={2}>
                                  <XCheckbox
                                    key="summary"
                                    id="summary"
                                    name={"summary"}
                                    label={"Summary"}
                                    value="1"
                                    includeTopPadding={true}
                                    onChange={setFieldValue}
                                    size={{}}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XCheckbox
                                    key="show_topics"
                                    id="show_topics"
                                    name={"show_topics"}
                                    label={"Show Topics"}
                                    value="1"
                                    includeTopPadding={true}
                                    onChange={setFieldValue}
                                    size={{}}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XCheckbox
                                    key="disable_formative"
                                    id="disable_formative"
                                    name={"disable_formative"}
                                    label={"Disable Formative"}
                                    value="1"
                                    includeTopPadding={true}
                                    onChange={setFieldValue}
                                    size={{}}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XCheckbox
                                    key="report_comments"
                                    id="report_comments"
                                    name={"report_comments"}
                                    label={"Show comments"}
                                    value="1"
                                    includeTopPadding={true}
                                    onChange={setFieldValue}
                                    size={{}}
                                  />
                                </Col>
                                <Col lg={4}>
                                  <XTextBox
                                    type="text"
                                    key="label"
                                    id="label"
                                    name={"label"}
                                    label={"Label"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <div>&nbsp;</div>
                                  <Button
                                    disabled={false}
                                    type="submit"
                                    className="btn btn-primary"
                                  >
                                    Next
                                  </Button>
                                </Col>
                              </Row>
                            </Form>
                          </>
                        )}
                      </Formik>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TerminalReports;
